import { useState } from "react";
import Table from "./_Table";

export default function Categories({categories, cvmCode}) {
    return categories.map((category, i) => {
        const title = lang === 'pt-br' ? category.descricao : category.descricao_en;
        const [open, setOpen] = useState(false);

        return (
            <li key={cvmCode +'_'+ i} className="pageCVM__singleCategory">
                <div
                    className={"pageCVM__singleCategory__header accordion__header" + (open ? ' active' : '')}
                    onClick={() => setOpen(!open)}>
                    <span className="pageCVM__singleCategory__name">{title}</span>

                    <div className="pageCVM__singleCategory__icon"></div>
                </div>

                <div className="pageCVM__singleCategory__content accordion__content">
                    <div className="table-responsive">
                        {open && <Table cvmCode={cvmCode} categoryID={category.id_categoria} documentID={category.id_documento} />}
                    </div>
                </div>
            </li>
        )
    });
}